import {Capacitor} from '@capacitor/core'
import {Deploy} from 'cordova-plugin-ionic/dist/ngx'
import {DeployMock} from '@cart/src/mock/deploy.mock'

/**
 * Factory function to provide platform-specific Deploy implementation
 * Returns real Deploy for native platforms, mock for web
 */
export function deployFactory(): Deploy | DeployMock {
  return Capacitor.isNativePlatform() ? new Deploy() : new DeployMock()
}
